import React from 'react';
import { CssBaseline, Card, CardActionArea, CardMedia, CardContent, Typography} from '@mui/material';

function PageMidThree (props) {
    return (
        <>
        <CssBaseline />
        <Card sx={{ maxWidth: 345}}>
            <CardActionArea>
                <CardMedia
                    component="img"
                    height="140"
                    image={props.img}
                    alt={props.alt} />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div" fontWeight="700">
                        {props.text}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {props.text2}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
        </>

    );
};
export default PageMidThree;